module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "600px",
      "margin": "24px"
    },
    attrs: {
      "src": _vm.topImg,
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "800px",
      "text-align": "left",
      "margin": "auto"
    }
  }, [_vm._v("Được thành lập năm 2017, VN Ngày Nay với công nghệ AI tiên tiến đã cán mốc hơn 35 triệu lượt cài đặt trên khắp cả nước. Nhờ tiềm năng và xu hướng công nghệ đón đầu thị trường, VN Ngày Nay đang không ngừng thu hút các dự án hợp tác chiến lược đến từ những tập đoàn quốc tế.\n    Và để đào tạo thêm một thế hệ nhân tài mới, VN Ngày Nay quyết định triển khai chương trình Asia Interns cho các sinh viên tiềm năng đến làm việc, sinh sống và trưởng thành ở các thành phố hàng đầu Châu Á hiện nay như Thâm Quyến, Bangkok, Manila.\n  ")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "800px",
      "margin": "24px auto 0"
    },
    attrs: {
      "src": _vm.introImg,
      "alt": ""
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "800px",
      "border": "2px solid #000",
      "margin": "0 auto 30px"
    }
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("BẠN SẼ ĐƯỢC")]), _vm._v(" "), _c('div', {
    staticClass: "intro-box"
  }, [_c('div', {
    staticClass: "intro-info"
  }, [_c('img', {
    attrs: {
      "src": _vm.intro01
    }
  }), _vm._v("\n        Thời gian làm việc linh hoạt , sắp xếp phù hợp với lịch học và lịch thi\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "intro-info"
  }, [_c('img', {
    attrs: {
      "src": _vm.intro02
    }
  }), _vm._v("\n        Thời gian làm việc linh hoạt , sắp xếp phù hợp với lịch học và lịch thi\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "intro-info"
  }, [_c('img', {
    staticStyle: {
      "height": "48px",
      "margin-left": "-33px"
    },
    attrs: {
      "src": _vm.intro03
    }
  }), _vm._v("\n        Thời gian làm việc linh hoạt , sắp xếp phù hợp với lịch học và lịch thi\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "intro-info"
  }, [_c('img', {
    attrs: {
      "src": _vm.intro04
    }
  }), _vm._v("\n        Thời gian làm việc linh hoạt , sắp xếp phù hợp với lịch học và lịch thi\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "intro-info"
  }, [_c('img', {
    attrs: {
      "src": _vm.intro05
    }
  }), _vm._v("\n        Thời gian làm việc linh hoạt , sắp xếp phù hợp với lịch học và lịch thi\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "intro-info"
  }, [_c('img', {
    attrs: {
      "src": _vm.intro06
    }
  }), _vm._v("\n        Thời gian làm việc linh hoạt , sắp xếp phù hợp với lịch học và lịch thi\n      ")])])]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("ĐIỀU KIỆN THAM GIA")]), _vm._v(" "), _c('div', {
    staticClass: "condition-box"
  }, [_c('div', {
    staticClass: "condition-item"
  }, [_c('img', {
    attrs: {
      "src": _vm.condition01
    }
  }), _vm._v(" "), _c('p', [_vm._v("Là sinh viên năm cuối, kế cuối với thành tích học tập ấn tượng")])]), _vm._v(" "), _c('div', {
    staticClass: "condition-item"
  }, [_c('img', {
    attrs: {
      "src": _vm.condition02
    }
  }), _vm._v(" "), _c('p', [_vm._v("Là sinh viên khá - giỏi vừa tốt nghiệp, kinh nghiệm làm việc dưới 1 năm")])]), _vm._v(" "), _c('div', {
    staticClass: "condition-item"
  }, [_c('img', {
    attrs: {
      "src": _vm.condition03
    }
  }), _vm._v(" "), _c('p', [_vm._v("Tiếng Anh lưu loát, giao tiếp tự tin, tư duy logic tốt, ham học hỏi và có tinh thần cầu tiến")])]), _vm._v(" "), _c('div', {
    staticClass: "condition-item"
  }, [_c('img', {
    attrs: {
      "src": _vm.condition04
    }
  }), _vm._v(" "), _c('p', [_vm._v("Yêu thích lĩnh vực công nghệ số - mobile app và mong muốn làm việc ở một thành phố công nghệ cao")])])]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("ĐỐI TÁC TIÊU BIỂU")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.company,
      "width": "800"
    }
  }), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    }
  }, [_c('div', {
    staticClass: "profession"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("PRODUCT"), _c('br'), _vm._v("OPERATION")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("\n        1. Tham gia thiết kế sản phẩm với lượng người dùng lên đến hàng chục triệu"), _c('br'), _vm._v("\n        2. Thu thập, phân tích các số liệu thị trường nhằm đưa ra chiến lược cho sản phẩm"), _c('br'), _vm._v("\n        3. Phân tích hành vi, tìm hiểu nhu cầu người dùng và lên ý tưởng tối ưu sản phẩm"), _c('br'), _vm._v("\n        4. Xử lý các vấn đề phát sinh trong quá trình vận hành sản phẩm"), _c('br'), _vm._v("\n        5. Tham gia hỗ trợ các hạng mục công nghệ số khác\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "profession"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("TECH"), _c('br'), _vm._v("FRESHER")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("\n        1. Tham gia phát triển chức năng và tối ưu hóa hiệu suất của sản phẩm"), _c('br'), _vm._v("\n        2. Thiết kế, phát triển và bảo trì các sản phẩm mới"), _c('br'), _vm._v("\n        3. Tham gia thảo luận với các Giám đốc Sản phẩm về nhu cầu và các tính năng mới"), _c('br'), _vm._v("\n        4. Dành riêng cho các sinh viên đang theo học hoặc vừa tốt nghiệp các ngành IT/Lập trình.\n      ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "width": "800px",
      "font-size": "22px",
      "color": "red",
      "text-align": "left",
      "margin": "24px auto 30px"
    }
  }, [_c('b', [_vm._v("\n      Thông tin liên hệ:"), _c('br'), _vm._v("\n      - Địa chỉ: 196 Hoàng Diệu, Phường 8, Quận 4, TP.HCM"), _c('br'), _vm._v("\n      - Phòng Nhân sự: 028.3636.2034"), _c('br'), _vm._v("\n      - Email: tuyendung@vngaynay.vn\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-720a8ad8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Want.vue
// module id = 995
// module chunks = 1